module.exports = __webpack_public_path__ + "img/plataformas-the-members.4163660c.svg";